import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'apps/new-web/views/component';
import Image from 'apps/new-web/views/components/image';
import I18n from 'apps/new-web/views/components/i18n';
import FacebookLoginWrapper from 'apps/new-web/views/components/facebook-login-wrapper';

class FacebookLogin extends BaseComponent {
  static get propTypes() {
    return {
      appId: PropTypes.string.isRequired,
      loginWithFacebook: PropTypes.func.isRequired
    };
  }

  render() {
    return (
      <FacebookLoginWrapper appId={ this.props.appId } onAccessToken={ this.props.loginWithFacebook }>
        <button className="facebook-login social-login">
          <Image src="/img/facebook.svg" width="24px" />
          <p><I18n args={{ facebook: 'Facebook' }}>Continue with [facebook]</I18n></p>
        </button>
      </FacebookLoginWrapper>
    );
  }
}

export default FacebookLogin;
